module.exports = __webpack_public_path__ + "img/font-awesome-logo-full.4589f18e.svg";